import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import {
  faChartLine,
  faFileLines,
  faReceipt,
  faMoneyBillTransfer,
  faCheck,
  faArrowRight,
  faBolt,
} from '@fortawesome/free-solid-svg-icons';

import './ContaPrimaraProgressPanel.css';


/* =====================================================
   DATE TEMPORARE

   Mai tarziu acestea vor veni din backend.
===================================================== */

const mockProgressData = {
  level: 1,

  levelName: 'In formare',

  completedLessons: 5,

  totalLessons: 131,

  skills: [
    {
      id: 1,
      name: 'Documente justificative',
      progress: 63,
      icon: faFileLines,
    },
    {
      id: 2,
      name: 'Facturare',
      progress: 0,
      icon: faReceipt,
    },
    {
      id: 3,
      name: 'Casa si banca',
      progress: 0,
      icon: faMoneyBillTransfer,
    },
  ],

  latestAchievement: {
    title: 'Identifici rolul contabilitatii primare',
    category: 'Bazele contabilitatii primare',
  },
};


const ContaPrimaraProgressPanel = ({
  progressData = mockProgressData,
  onViewSkills,
}) => {

  /* =====================================================
     PROGRES GENERAL
  ===================================================== */

  const overallProgress =
    progressData.totalLessons > 0
      ? Math.round(
          (
            progressData.completedLessons /
            progressData.totalLessons
          ) * 100
        )
      : 0;


  /* =====================================================
     VEZI TOATE COMPETENTELE
  ===================================================== */

  const handleViewSkills = () => {
    if (onViewSkills) {
      onViewSkills();
    }
  };


  return (
    <div className="conta-primara-progress-panel">


      {/* =================================================
          PROGRES GENERAL
      ================================================= */}

      <section className="conta-primara-progress-card">

        <div className="conta-primara-progress-card-header">

          <div>

            <span className="conta-primara-progress-eyebrow">
              PROGRESUL TAU
            </span>

            <h3>
              Contabilitate primara
            </h3>

          </div>

          <div className="conta-primara-progress-header-icon">
            <FontAwesomeIcon icon={faChartLine} />
          </div>

        </div>


        {/* NIVEL */}

        <div className="conta-primara-progress-level">

          <div className="conta-primara-progress-level-number">
            <p>{progressData.level}</p>
          </div>

          <div className="conta-primara-progress-level-content">

            <span>
              Nivel {progressData.level}
            </span>

            <strong>
              {progressData.levelName}
            </strong>

          </div>

        </div>


        {/* PROGRES */}

        <div className="conta-primara-progress-overall">

          <div className="conta-primara-progress-overall-top">

            <span>
              Progres curs
            </span>

            <strong>
              {overallProgress}%
            </strong>

          </div>


          <div className="conta-primara-progress-bar">

            <div
              className="conta-primara-progress-fill"
              style={{
                width: `${overallProgress}%`,
              }}
            />

          </div>


          <p>
            {progressData.completedLessons}
            {' '}
            din
            {' '}
            {progressData.totalLessons}
            {' '}
            lectii finalizate
          </p>

        </div>

      </section>


      {/* =================================================
          COMPETENTE
      ================================================= */}

      <section className="conta-primara-progress-card">

        <div className="conta-primara-progress-section-title">

          <div>

            <span className="conta-primara-progress-eyebrow">
              COMPETENTE
            </span>

            <h3>
              Ce dezvolti acum
            </h3>

          </div>

          <FontAwesomeIcon
            icon={faBolt}
            className="conta-primara-progress-section-icon"
          />

        </div>


        <div className="conta-primara-progress-skills">

          {progressData.skills.map((skill) => (

            <div
              key={skill.id}
              className="conta-primara-progress-skill"
            >

              <div className="conta-primara-progress-skill-top">

                <div className="conta-primara-progress-skill-name">

                  <span className="conta-primara-progress-skill-icon">
                    <FontAwesomeIcon icon={skill.icon} />
                  </span>

                  <span>
                    {skill.name}
                  </span>

                </div>

                <strong>
                  {skill.progress}%
                </strong>

              </div>


              <div className="conta-primara-progress-skill-bar">

                <div
                  className="conta-primara-progress-skill-fill"
                  style={{
                    width: `${skill.progress}%`,
                  }}
                />

              </div>

            </div>

          ))}

        </div>


        <button
          type="button"
          className="conta-primara-progress-view-skills"
          onClick={handleViewSkills}
        >
          Vezi toate competentele

          <FontAwesomeIcon icon={faArrowRight} />
        </button>

      </section>


      {/* =================================================
          ULTIMA ABILITATE
      ================================================= */}

      {progressData.latestAchievement && (

        <section className="conta-primara-progress-card">

          <span className="conta-primara-progress-eyebrow">
            ABILITATE DOBANDITA
          </span>


          <div className="conta-primara-progress-achievement">

            <div className="conta-primara-progress-achievement-icon">
              <FontAwesomeIcon icon={faCheck} />
            </div>


            <div className="conta-primara-progress-achievement-content">

              <strong>
                {progressData.latestAchievement.title}
              </strong>

              <span>
                {
                  progressData.latestAchievement.category
                }
              </span>

            </div>

          </div>

        </section>

      )}

    </div>
  );
};

export default ContaPrimaraProgressPanel;